import { ErrorCode } from '@/types/error-code.enum';

export class AppError extends Error {
  public code: ErrorCode;
  public meta?: object;

  constructor(message: string, code: ErrorCode, meta?: object) {
    super(message);
    this.code = code;
    this.meta = meta;
  }
}
